// GENERATE BY SVGR, DON NOT EDIT IT MANUALLY
import React from 'react';
interface SvgCompProps {
    className?: string;
    style?: React.CSSProperties;
    onClick?: React.MouseEventHandler<SVGSVGElement>;
}
const SvgSwitch = (props: SvgCompProps, ref: React.Ref<SVGSVGElement>) => {
    const svgProps = {
        width: '1em',
        height: '1em',
        fill: 'currentColor',
        'aria-hidden': true,
        focusable: false,
        ...props
    };
    return (
        <svg viewBox="0 0 1024 1024" {...svgProps} ref={ref}>
            <path d="M724.8 912c-11.2 0-19.2-3.2-27.2-11.2-16-14.4-16-40-1.6-56l81.6-84.8H150.4c-22.4 0-40-17.6-40-40s17.6-40 40-40h628.8l-89.6-83.2c-8-6.4-11.2-16-12.8-27.2 0-11.2 3.2-20.8 11.2-28.8 6.4-8 16-11.2 27.2-11.2 9.6 0 20.8 3.2 28.8 11.2l156.8 145.6c8 6.4 12.8 16 12.8 27.2 0 12.8-3.2 20.8-11.2 28.8l-148.8 160c-8 4.8-17.6 9.6-28.8 9.6M310.4 497.6c-11.2 0-19.2-3.2-27.2-11.2l-160-147.2c-8-6.4-12.8-17.6-12.8-27.2 0-11.2 3.2-20.8 11.2-27.2l148.8-160c6.4-8 17.6-12.8 28.8-12.8 9.6 0 19.2 3.2 27.2 11.2s12.8 17.6 12.8 28.8-3.2 20.8-11.2 27.2l-83.2 86.4h628.8c22.4 0 40 17.6 40 40s-17.6 40-40 40H246.4l89.6 83.2c8 6.4 12.8 17.6 12.8 27.2 0 11.2-3.2 20.8-11.2 27.2-6.4 9.6-19.2 14.4-27.2 14.4" />
        </svg>
    );
};
SvgSwitch.displayName = 'SvgSwitch';
export default React.memo(React.forwardRef(SvgSwitch));
